// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"582":"93b27236","632":"15f5ca2f"}[chunkId] + ".chunk.js";
};